export const AUTH_TOKEN = "CREDIFIN_TOKEN"
export const ENTERED_FROM_LOGIN = "entered_from_login";
export const IS_FILIAL_SELECTED = "isFilialSelected";
export const SISTEMA = "administracion";
export const ACUERDOS_PROXIMOS_KEY = "ACUERDOS_PROXIMOS_SHOWN";
